import React from "react";

const jobs = [
  {
    title: "Sales Officer",
    role: "Drive sales and collections while building strong customer relationships.",
    responsibilities:
      "Achieve targets, promote products, ensure timely reporting, and support business growth.",
    requirements: [
      "Postgraduate with 1–5 years of sales experience in MSME, strong communication skills, and willingness to work in the field.",
      "Age Limit: 22 - 30 years.",
      "Mandatory: Bike + Driving Licence.",
    ],
    location: "Multiple locations across India.",
    perks:
      "Fixed salary (Monthly CTC: ₹20,000 – ₹23,000) + Performance Incentive + Fuel + Travel Allowance + PF + ESI + Insurance.",
    applyEmail: "HR@svcl.in",
  },
  {
    title: "Branch Manager",
    role: "Lead branch operations, drive business growth, and ensure compliance with company policies.",
    responsibilities:
      "Achieve sales & collection targets, manage branch team, ensure customer satisfaction, maintain audit & compliance standards, and support field staff.",
    requirements: [
      "Postgraduate with 4–8 years of experience in MSME/Banking, strong leadership & communication skills, and ability to manage teams effectively.",
      "Age Limit: 25-35 years.",
      "Mandatory: Bike + Driving Licence.",
    ],
    location: "Multiple locations across India.",
    perks:
      "Fixed salary (Monthly CTC: ₹30,000 – ₹35,000) + Performance Incentive + Fuel + Travel Allowance + PF + Insurance.",
    applyEmail: "HR@svcl.in",
  },
];

function JobList() {
  return (
    <section className="job-vacancies-section">
      <div className="container">
        <div className="main-heading">JOB VACANCIES</div>
        <table className="min-w-full border border-gray-300 rounded-lg shadow-sm overflow-hidden">
          <thead className="text-left hover-row">
            <tr>
              <th className="px-4 py-3 border">Title</th>
              <th className="px-4 py-3 border">Role</th>
              <th className="px-4 py-3 border">Responsibilities</th>
              <th className="px-4 py-3 border">Requirements</th>
              <th className="px-4 py-3 border">Location</th>
              <th className="px-4 py-3 border">Perks & Benefits</th>
              <th className="px-4 py-3 border">Apply</th>
            </tr>
          </thead>
          <tbody>
            {jobs.map((job, index) => (
              <tr key={index} className="hover-row">
                <td className="px-4 py-3 border font-semibold">{job.title}</td>
                <td className="px-4 py-3 border">{job.role}</td>
                <td className="px-4 py-3 border">{job.responsibilities}</td>
                <td className="px-4 py-3 border">
                  <ul>
                    {job.requirements.map((req, i) => (
                      <li key={i}>{req}</li>
                    ))}
                  </ul>
                </td>
                <td className="px-4 py-3 border">{job.location}</td>
                <td className="px-4 py-3 border">{job.perks}</td>
                <td className="px-4 py-3 border text-center">
                  Send CV to{" "}
                  <a
                    href={`mailto:${job.applyEmail}`}
                    className="text-blue-600 underline"
                  >
                    {job.applyEmail}
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
export default JobList;
